<template>
  <span v-if="icon">
    <v-menu
      v-if="flag && flag.icon && flag.name && flag.tooltip"
      :color="themes.candidate.light.tooltip"
      nudge-bottom="30"
      class="px-0"
      open-on-hover
      bottom
      left
    >
      <v-btn icon slot="activator" @click.stop="" class="ma-0">
        <v-icon :color="themes.candidate.light[flagColor]" class="text-vertical-middle">
          {{ flag.icon }}
        </v-icon>
      </v-btn>
      <v-card :class="themes.candidate.light.dialogTitle">
        <v-card-title class="font-weight-bold pb-0">Flagged: {{ flag.name }}</v-card-title>
        <v-card-text class="pt-1">
          {{ flag.tooltip }}

          <div v-if="value.resolvedAt" class="pt-2">
            <v-icon :color="themes.candidate.light.success" class="text-vertical-middle pr-1" small>
              mdi-checkbox-marked
            </v-icon>
            <span>
              Resolved on {{ new Date(value.resolvedAt) | date("d MMM yyyy 'at' HH:mm") }}
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </span>
  <span v-else>
    <div class="font-weight-bold pb-2">
      <v-icon :color="themes.candidate.light[flagColor]" class="text-vertical-middle pr-2" small>
        {{ flag.icon }}
      </v-icon>
      <span>Flagged: {{ flag.name }}</span>
    </div>
    <div>
      {{ flag.tooltip }}
    </div>
    <div v-if="value.resolvedAt" class="pt-2">
      <v-icon :color="themes.candidate.light.success" class="text-vertical-middle pr-1" small>
        mdi-checkbox-marked
      </v-icon>
      <span>
        Resolved on {{ new Date(value.resolvedAt) | date("d MMM yyyy 'at' HH:mm") }}
      </span>
    </div>
  </span>
</template>

<script>
// Data
import flags from '@/data/flags'

// Helpers
import _ from 'lodash'

export default {
  props: { value: Object, icon: { type: Boolean, default: () => false } },

  data() {
    return {
      flags,
    }
  },

  computed: {
    flagColor() {
      return this.value.isSevere ? 'error' : 'warning'
    },

    flag() {
      if (!_.get(this, 'flags[0]') || !_.get(this, 'value.key')) return

      return this.flags.find(f => f.key === this.value.key)
    },
  },
}
</script>
